import styled from "styled-components";
import { grey } from "@material-ui/core/colors";
import { Paper, ListItemIcon, Grid, Button, Checkbox, ListItem, ListItemText, Typography } from "@material-ui/core";

export const STPaper = styled(Paper)`
  && {
    width: 255px;
    height: 230px;
    overflow: auto;
  }
`;

export const STListItemIcon = styled(ListItemIcon)`
  && {
    margin: 0;
    min-width: 0;
  }
`;

export const STListItem = styled(ListItem)`
  && {
    padding-top: 6px;
    padding-bottom: 6px;
  }
`;

export const STGridRoot = styled(Grid)`
  && {
    margin: auto;
    padding-top: 8px;
    padding-bottom: 16px;
    justify-content: flex-start;
  }
`;

export const STTitle = styled.span`
  padding-left: 8px;
  padding-bottom: 4px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
`;

export const STButton = styled(Button)`
  && {
    margin: 4px;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const STCheckbox = styled(Checkbox)`
  && {
    padding: 0;
    color: ${grey[500]} !important;
  }
`;

export const STListItemText = styled(ListItemText)`
  && {
    margin: 0;
    padding: 0 16px;
  }
`;

export const STTypography = styled(Typography)`
  && {
    font-size: 0.8125rem;
  }
`;
